import { IconButton } from '@wix/design-system';
import { Sound, SoundOff } from '@wix/wix-ui-icons-common';
import React, { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { IChatToggleMuteAction } from '../../../common/reducers/types';
import { selectIsMuted } from '../../../common/selectors/chat';
import { ACTIONS } from '../../../constants';
import { cookie } from '../../../util/cookie';
import { headerFullPageDataHooks } from '../HeaderFullPage/HeaderFullPage.dataHooks';

const cookieName = 'isMuted';

const toggleMute = (isMuted: boolean): IChatToggleMuteAction => ({
  type: ACTIONS.CHAT_TOGGLE_MUTE,
  isMuted,
});

export const MuteButton: FC = () => {
  const isMuted = useSelector(selectIsMuted);
  const dispatch = useDispatch();

  const onToggleMute = useCallback(() => {
    const mute = !isMuted;

    dispatch(toggleMute(mute));
    cookie.set(cookieName, mute);
  }, [isMuted, dispatch]);

  return (
    <IconButton
      skin="light"
      priority="secondary"
      size="small"
      onClick={onToggleMute}
      dataHook={headerFullPageDataHooks.toggleMute()}
    >
      {isMuted ? <SoundOff /> : <Sound />}
    </IconButton>
  );
};
